 <template>
  <div class="container-view">
    <nav class="add-navigation">
      <div
        @click="$router.push({ name: 'system-admin-company-list' })"
        class="back-link"
      >
        <svg
          class="icon"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to Company</p>
      </div>
      <div class="buttons-wrapper">
        <div class="primary-button">
          <primary-button @click.native="() => showAddModal()"
            >Add Account</primary-button
          >
        </div>
      </div>
    </nav>
    <div
      class="table_div"
      style="width: 100%; overflow-x: auto; overflow-y: hidden"
    >
      <table class="Invoice_table">
        <thead>
          <tr class="Invoice_table_header">
            <th class="name-status">User Name</th>
            <th>Password</th>
            <th>Allowed IPs</th>
            <th>Product</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr class="line" v-for="(user, k) in users" :key="k">
            <th class="name-status d-flex align-items-center">
              <div
                class="status mx-2"
                :class="user.is_active ? 'green' : 'red'"
              ></div>
              <div>{{ user.user_name }}</div>
            </th>
            <th>{{ user.passwd }}</th>
            <th>{{ user.allowed_ip_list }}</th>
            <th>
              {{
                user.products.length !== 0 ? user.products[0].product_name : ""
              }}
            </th>
            <th class="icon">
              <svg
                @click="() => show(user.user_id)"
                class="svg-grey"
                width="30px"
                height="30px"
                viewBox="0 0 30 30"
                version="1.1"
              >
                <path
                  d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                  id="path-1"
                />
              </svg>
              <svg
                @click="() => deleteUser(user.user_id)"
                class="svg-grey delete"
                width="30px"
                height="30px"
                viewBox="0 0 30 30"
                version="1.1"
              >
                <path
                  d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                  id="path-1"
                />
              </svg>
            </th>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="per-page">
      <span class="filter_by custom-row">Show Per Page:</span>
      <div class="primary-input-container choose-type perPage">
        <primary-select
          type="text"
          @input="changePerPage"
          v-model="per_page" :is-cross="false"
          class="choose-type perPage"
          placeholder="Select"
        >
          <option :value="item" v-for="(item, key) in pages" :key="key">
            {{ item }}
          </option>
        </primary-select>
      </div>
    </div>
    <div class="buttons-wrapper">
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :total="TotalPages"
        :perPage="per_page"
        :qnt="users.length"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import EditAccount from "./EditCompanyAccountModal.vue";
import AddAccount from "./AddCompanyAccountModal.vue";

export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
  },
  data: () => ({
    statusTypes: ["Active", "InActive"],
    users: [],
    Page: 0,
    per_page: 10,
    pages: [10, 50, 100],
    TotalPages: null,
    user: {
      user_name: null,
      first_name: null,
      last_name: null,
      passwd: null,
      products: [],
      allowed_ip_list: null,
      is_active: null,
      company_uuid: null,
    },
    companyId: null,
  }),
  computed: {
    ...mapGetters({
      getProducts: "products/getProducts",
      totalItems: "products/getTotal",
    }),
    products() {
      return this.getProducts.map((item) => {
        return { name: item.product_name, value: item.product_uuid };
      });
    },
  },
  created: async function () {
    (this.companyId = this.$route.params.id), this.GetList();
    await this.getProductList();
  },
  methods: {
    ...mapActions({
      viewAllProducts: "products/getProductList",
    }),
    changePerPage(e) {
      this.Page = 0;
      this.GetList();
    },
    showAddModal() {
      this.$modal.show(
        AddAccount,
        { companyId: this.companyId },
        {
          draggable: true,
          width: "70%",
          height: "auto",
          scrollable: true,
          clickToClose: false,
        },
        {
          "before-close": this.beforeClose,
        }
      );
    },
    show(id) {
      this.$modal.show(
        EditAccount,
        { id, companyId: this.companyId },
        {
          width: "70%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": this.beforeClose,
        }
      );
    },
    beforeClose() {
      this.GetList();
    },
    getProductList: async function () {
      await this.viewAllProducts({ company_uuid: this.companyId });
      await this.viewAllProducts({
        perPage: this.totalItems,
        company_uuid: this.companyId,
      });
    },
    getCompany: async function (id) {
      return await this.$store.dispatch("GetCompany", id);
    },
    changePage(page) {
      this.Page = page;
      this.GetList();
    },
    GetList: async function () {
      this.$store
        .dispatch("GetUsers", {
          page: this.Page,
          companyId: this.companyId,
          per_page: this.per_page,
        })
        .then((res) => {
          this.Page = res.page;
          this.TotalPages = res.total / res.per_page;
          this.users = res.items;
        });
    },
    deleteUser(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this user!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("DeleteUser", id)
            .then(() => {
              this.$swal({ text: "user has been deleted.", type: "success" });
              this.GetList();
            })
            .catch((err) => {
              this.$snotify.error(err.response.data.errors);
            });
        }
      });
    },
  },
};
</script>
 <style>
 @media (max-width: 766px) {
    .v--modal-box {
   top: 15px !important;
 }
 }

 </style>

<style lang="scss" scoped>
.container-view {


  width: 100%;
  padding: 0 20px;

  .help {
    margin-top: 10px;
  }
  .per-page {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .perPage {
    width: 120px;
    margin-right: 15px;
  }
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 140px;
      }
    }
  }
}
table.Invoice_table {
  width: 100%;

  th {
    text-align: center;
  }
  //   tbody tr:nth-of-type(odd) {
  //     background-color: rgba(0, 0, 0, 0.05);
  // }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
  th {
    border-bottom-width: 2px;
    color: white;
    padding-left: 10px;
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
    border: 1px solid #dee2e6;
  }
}
table,
tr {
  width: 100%;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}

table {
  border-collapse: collapse;

  .name-status {
    position: relative;
    width: 250px;
  }
}
.Invoice_table_popup {
  width: 75px;
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}
tbody th:first-child {
  padding-left: 0px;
}
tbody th {
  font-size: 14px;
  font-weight: unset;
  padding-left: 20px;

  .status {
    width: 10px;
    height: 10px;
    border-radius: 50%;

    &.green {
      background: #24e2b8;
    }
    &.red {
      background: #d2305b;
    }
  }
  .primary-input-container {
    padding-right: 10px;
    margin-top: 20px;
    .pimary-input-title {
      display: none !important;
    }
    .primary-input {
      padding-right: 10px;
    }
  }
}
.Invoice_price {
  font-family: "Helvetica Neue";
}
th.icon {
  padding: 7px 0;
  height: 44px;
  width: 100px;
  .svg-grey {
    height: 30px;
    width: 30px;
    cursor: pointer;
    fill: #55616e;
  }
  .delete {
    margin-left: 5px;
    // margin-right: 20px;
    // float: right;
  }
}
th.product {
  width: 200px;
}
@media (max-width: 1210px) {
  table.Invoice_table {
    width: 1105px;
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;

  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}

  .line {
    vertical-align: baseline;
  }
</style>